module.exports = __webpack_public_path__ + "static/img/gh.caedb912.svg";